module.exports = "../study/imgs/maps/Tokyo/S8/WaterEnvironment/Chlave/Tokyo_Chlave_MRI_RCP85_Now.png";